import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { Inbox } from "lucide-react";
import { get } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { STAFF } from "@/lib/nav";
import { NextActionButton } from "@/components/app/NextActionButton";

export function InboxCard() {
  const { user } = useAuth();
  const staff = STAFF.includes(user.role);
  const { data } = useQuery({ queryKey: ["inbox-actions"], queryFn: () => get("/inbox/actions"), refetchInterval: 30000 });
  if (!data) return <div className="tl-skel h-32 rounded-[6px]" />;
  const hm = user.role === "hiring_manager";
  return (
    <section className="panel space-y-3 p-5" data-testid="inbox-card" data-tour="inbox">
      <div className="flex items-center gap-2">
        <Inbox size={18} className="text-brand" aria-hidden />
        <h2 className="text-base font-semibold">{hm ? "Decisions waiting for you" : "Needs your attention"}</h2>
        <span className="text-sm text-ink-muted" data-testid="inbox-total">{data.total}</span>
      </div>
      {!data.rows.length ? <p className="text-sm text-ink-muted" data-testid="inbox-empty">{hm ? "Nothing to decide right now. We'll show candidates here when they're ready for you." : "You're all caught up."}</p> : (
        <ul className="divide-y divide-line">
          {data.rows.slice(0, 8).map((r, i) => (
            <motion.li key={r.application_id} initial={{ opacity: 0, x: -6 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.03 }}
              className="flex flex-wrap items-center gap-3 py-2.5" data-testid={`inbox-row-${r.application_id}`}>
              <div className="min-w-[180px] flex-1"><p className="text-sm font-medium">{r.name}</p><p className="text-xs text-ink-muted">{r.job_title} · {r.next.why}</p></div>
              <NextActionButton row={r} canAct={staff || r.next.action === "open" || r.next.action === "decide"} />
            </motion.li>
          ))}
        </ul>
      )}
    </section>
  );
}
